export default __webpack_public_path__ + "static/1.7.6/media/diagmaticLogo.4ca2809a.svg";